module.exports = __webpack_public_path__ + "img/login-newbg-phone.2a26237c.png";